"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const types_1 = require("../types");
const curtain_1 = __importDefault(require("../curtain"));
const utils_1 = require("../utils");
const container_with_timer_styles_1 = __importDefault(require("./container-with-timer.styles"));
const b = b_1.default.with('container-with-timer');
/* type ContainerWithTimerProps = PropsWithChildren<{
    timeLimit: number;
    timeLimitType: TimeLimitType;
    tpl: string
} & StatusProps>; */
const ContainerWithTimer = props => {
    const { children, timeLimit, timeLimitType, tpl, status, handleStatus, collapseView, onShow } = props;
    const [delay, setDelay] = (0, react_2.useState)();
    const onHide = (0, react_2.useCallback)(() => {
        handleStatus(types_1.AttachmentStatus.End);
        if (timeLimitType === types_1.TimeLimitType.NOT_MORE) {
            collapseView();
        }
    }, [handleStatus, collapseView, timeLimitType]);
    const handleClick = (0, react_2.useCallback)(() => {
        onShow();
        if (timeLimitType === types_1.TimeLimitType.NOT_LESS || timeLimitType === types_1.TimeLimitType.NOT_MORE) {
            // @ts-expect-error TS(2345): Argument of type 'Timeout' is not assignable to pa... Remove this comment to see the full error message
            setDelay(setTimeout(onHide, timeLimit * 1000));
        }
    }, [onShow, timeLimitType, onHide, timeLimit]);
    (0, react_2.useEffect)(() => {
        return () => {
            if (delay) {
                clearTimeout(delay);
            }
        };
    }, [delay]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: container_with_timer_styles_1.default }), children, (0, jsx_runtime_1.jsx)(curtain_1.default, { status: status, handleClick: handleClick, text: (0, utils_1.buildSecondsTpl)(tpl, timeLimit, 'ro') })] })));
};
exports.default = ContainerWithTimer;
